import { render, staticRenderFns } from "./SportsAutocomplete.vue?vue&type=template&id=ee4239d4&scoped=true"
import script from "./SportsAutocomplete.vue?vue&type=script&lang=js"
export * from "./SportsAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4239d4",
  null
  
)

export default component.exports